import {
  apiClient,
  type PageEntity,
  type PackageCategoryImportJobExEntity
} from '@/libs/api'
import { type PackageCategoryImportJobsRequestQuery } from '@/libs/api/types'

export type FetchPackageCategoryImportJobsQuery = {
  tenantKey: string
  query: PackageCategoryImportJobsRequestQuery
}

export type FetchPackageCategoryImportJobsResponse = {
  data: PackageCategoryImportJobExEntity[]
  pagination: PageEntity | null
}

export const fetchPackageCategoryImportJobs = async (
  { tenantKey, query }: FetchPackageCategoryImportJobsQuery,
  signal?: AbortSignal
): Promise<FetchPackageCategoryImportJobsResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .package_category_import_jobs.$get({
      query,
      config: {
        signal
      }
    })
  return {
    data,
    pagination
  }
}
